import axios from 'axios'

export default {
  namespaced: true,

  state: {
    token: null,
    err: null,
    status: null
  },

  mutations: {
    SET_USER (state, token) {
      state.token = token
    },

    SET_STATUS (state, data) {
      state.status = data
    }
  },

  actions: {
    async checkLog ({ commit, state }, params) {
      try {
        const response = await axios.post('/login', params)
        commit('SET_STATUS', response.status)
        commit('SET_USER', response.data)
      } catch (err) {
        console.error(err.response)
        if (err.response) {
          commit('SET_STATUS', err.response.status)
        }
      }
    },

    async logout () {
      await axios.post('/logout')
    },

    async getInfo ({ commit }, params) {
      let result = await axios
        .get(`/auth`)
      return result.data
    }
  }
}
